module.exports = new __parcel__URL__("give_medication_button.10ba8dd9.png").toString();